import React from 'react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {RsvpInfoButton} from '../rsvp-info-button'
import {TicketsUnavailableButtonProps} from './index'

export const TicketsUnavailableButton: React.FC<TicketsUnavailableButtonProps> = ({
  ticketsUnavailableMessages,
  href,
}) => <RsvpInfoButton messages={ticketsUnavailableMessages} dataHook={DH.TICKETS_UNAVAILABLE} href={href} />
